// PublicRoute.js
import React from "react";
import { useSelector } from "react-redux";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { RoleEnum } from "../shared/model";

const PublicRoute = () => {
    const { user } = useSelector((state: any) => state.auth);
    const isProfessional =
        Number(user?.role?.id) === RoleEnum.professional ||
        Number(user?.role?.id) === RoleEnum.internationl_professional;
    if (!user) {
        // Not logged in → redirect to login
        return <Outlet />;
    }

    // Restrict access to professional routes for non-professionals
    if (isProfessional) {
        return <Navigate to="/professionals" replace />;
    }
    console.log("here");
    // Restrict access to client routes for non-clients (optional)
    if (Number(user?.role?.id) === RoleEnum.client) {
        return <Navigate to="/clients" replace />;
    }

    if (Number(user?.role?.id) === RoleEnum.admin) {
        return <Navigate to="/admin" replace />;
    }
};

export default PublicRoute;
